import { createContext, useContext } from 'react';

import type { ViewerMode } from 'constants/all';

/**
 * The user's relationship to the part being shown. A shared part is viewed
 * through someone else's share grant.
 */
export type ViewerAccess = {
  relationship: ViewerMode;
};

export const ViewerAccessContext = createContext<ViewerAccess | null>(null);

export const useViewerAccess = (): ViewerAccess => {
  const value = useContext(ViewerAccessContext);
  if (value === null) {
    throw new Error('ViewerAccess must be provided by the viewer host');
  }
  return value;
};
